module.exports = __webpack_public_path__ + "img/bars-solid.c8e3f88b.svg";